import { Link as ScrollLink } from 'react-scroll';
import { FaWhatsapp } from "react-icons/fa";
import { PiTiktokLogoLight } from 'react-icons/pi';
import { GiNewspaper } from 'react-icons/gi';
import { useTranslation } from "react-i18next";







function Center() {

  const { t } = useTranslation();
  return (
    <main>
      <div className="firstMain" name='skizb' >

        <video
          className="bgVideo"
          src="/image/VideoDrone122.mp4"
          autoPlay
          loop
          muted
          playsInline
        />


        <div className="text1">
          <p>{t("text11")}</p>
          {/* <h1>Որտեղ նորարարությունը <br /> թռիչք է կատարում, և սկսվում <br /> է գյուղատնտեսության ապագան։</h1> */}
          <h1>{t("text12")}</h1>

          <div className="mainBtn1">
            <ScrollLink to="carayutyunner" smooth={true} duration={500} offset={-40} >
              <button className="mainBtn1-1">
                {t("btn2")}
              </button></ScrollLink>
            <a href="https://wa.me/37433809009" target='blank' className='a85'>
              <button className="mainBtn1-2">  {t("btn3")}<FaWhatsapp fontSize={'21px'} color='#25d366' /></button>
            </a>
          </div>
        </div>
      </div>
      <div className='service' name='carayutyunner'>
        <div className='vernagir1' >
          <p>{t("text13")}</p>
        </div>
        < div className='services'>
          <div className='service1'>
            <div className='servicesimage1'>
              <video
                className="bgVideo1"
                src="/image/spraying1.mp4"
                autoPlay
                loop
                muted
                playsInline
              />
              <h2>{t("text14")}</h2>
            </div>
            <div className='servicesimagetext1'>
              <p>{t("text15")}</p>

            </div>
          </div>
          <div className='service2'>
            <div className='servicesimage2'>
              <video
                className="bgVideo2"
                src="/image/spraying2.mp4"
                autoPlay
                loop
                muted
                playsInline
              />
              <h2>{t("text16")}</h2>

            </div>
            <div className='servicesimagetext2'>

              <p>{t("text17")}</p>
            </div>
          </div>
          <div className='service3'>
            <div className='servicesimage3'>

              <video
                className="bgVideo3"
                src="/image/spraying3.mp4"
                autoPlay
                loop
                muted
                playsInline
              />

              <h2>{t("text18")}</h2>

            </div>
            <div className='servicesimagetext3'>
              <p>{t("text19")}</p>
            </div></div>
          <div className='service4'>
            <div className='servicesimage4'>
              <video
                className="bgVideo4"
                src="/image/spraying4.mp4"
                autoPlay
                loop
                muted
                playsInline
              />
              <h2>{t("text20")}</h2>

            </div>
            <div className='servicesimagetext4'>
              <p>{t("text21")}</p>
            </div>
          </div>



        </div>


      </div>


      <div className='aboutUs' name='aboutUs' >
        <div className='aboutUsText'>
          <p>{t("text22")}</p>
          <h1>{t("text23")}</h1>

        </div>
        <div className='lurer'>
          <div>
            <a
              href="https://youtu.be/aI0MdIWN0ts?si=oMzus2uAC7snQ9Jb"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-card"
            >
              <img
                src="/image/haylur1.png"
                alt="YouTube video"
              />

              <div className="play-btn">
                ▶
              </div>
            </a></div>
          <div>
            <a
              href="https://www.mineconomy.am/news/3739"
              target="blank"
              rel="noopener noreferrer"
              className="youtube-card"
            >
              <img
                src="/image/ffgg.png"
                alt="News"
              />

              <div className="play-btn1">
                <GiNewspaper />
              </div>

            </a>



          </div>



        </div>
        <div><a
          href="https://youtu.be/7EjUXTE-85k?si=BNCY9HcY2210YAya"
          target="_blank"
          rel="noopener noreferrer"
          className="youtube-card"
        >
          <img
            src="/image/haylur2.png"
            alt="YouTube video"
          />

          <div className="play-btn">
            ▶
          </div>
        </a>
        </div>


      </div>




      <div className='aravelutyun' name='aravelutyunner'>
        <div className='vernagir2'>
          <p>{t("text24")}</p>

        </div>
        <div className='aravelutyunner'>
          <div className="keter">
            <div className='nshan'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ariaHidden="true"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path></svg>
            </div>
            <h1>{t("text25")}</h1>
            <p>{t("text26")}</p>
          </div>
          <div className="keter">
            <div className='nshan'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ariaHidden="true"><path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"></path></svg>
            </div>
            <h1>{t("text27")}</h1>
            <p>{t("text28")}</p>
          </div>
          <div className="keter">
            <div className='nshan'>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ariaHidden="true"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle></svg>
            </div>
            <h1>{t("text29")}</h1>
            <p>{t("text30")}</p>
          </div>
          <div className="keter">
            <div className='nshan'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ariaHidden="true"><line x1="12" x2="12" y1="2" y2="22"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>
            </div>
            <h1>{t("text31")}</h1>
            <p>{t("text32")}</p>
          </div>
          <div className="keter">
            <div className='nshan'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ariaHidden="true"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"></path><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"></path></svg>
            </div>
            <h1>{t("text33")}</h1>
            <p>{t("text34")}</p>
          </div>


        </div>

      </div>
      <div className='kap' name='kap'>
        <div className='vernagir3'>
          <p>{t("text35")}</p>
          <h1>{t("text36")}</h1>
          <h3>{t("text37")}</h3>
        </div>
        <div className='kapMijocner'>
          <div className='mijoc' onClick={() => { window.location.href = 'tel:+37433809009' }}  >
            <div className='mijocKorp'>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ariaHidden="true"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg>
            </div>
            <div  >

              <p>{t("text38")}</p>
              <h2>{t("text39")}</h2>
            </div>
          </div>
          <div className='mijoc' onClick={() => { window.open("mailto:info@agrodrone.am") }}   >
            <div className='mijocKorp'>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ariaHidden="true"><path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path><rect x="2" y="4" width="20" height="16" rx="2"></rect></svg>
            </div>
            <div>

              <p>{t("text40")}</p>
              <h2>{t("text41")}</h2>
            </div>
          </div>
          <div className='mijoc' onClick={() => { window.open('https://yandex.com/maps/-/CPabbP0J') }}     >
            <div className='mijocKorp'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ariaHidden="true"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path><circle cx="12" cy="10" r="3"></circle></svg>
            </div>
            <div>

              <p>{t("text42")}</p>
              <h2>{t("text43")}</h2>

            </div>
          </div>
          <div className='mijoc' >
            <div className='mijocKorp'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ariaHidden="true"><path d="M12 6v6l4 2"></path><circle cx="12" cy="12" r="10"></circle></svg>
            </div>
            <div>
              <p>{t("text44")}</p>
              <h2>{t("text45")}</h2>
            </div>
          </div>




        </div>
        <div className='socCanc1'>
          <div>

            <p>{t("text46")}</p>
          </div>
          <div className='face'>
            <div className='f1' onClick={() => { window.open('https://www.facebook.com/share/1BR9h94YHG/?mibextid=wwXIfr') }}    >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ariaHidden="true"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>
            </div>
            <div className='f2' onClick={() => { window.open('https://www.instagram.com/hgh_agro_drones/?utm_source=ig_web_button_share_sheet') }} >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ariaHidden="true"><rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"></line></svg>
            </div>
            <div className='f3' onClick={() => { window.open('https://www.tiktok.com/@hgh.agro.drones?_r=1&_t=ZS-943ziFgM6pJ') }} >
              <PiTiktokLogoLight fontSize={'29px'} />
            </div>
          </div>



        </div>



      </div>


    </main>
  )
}

export default Center
